export const state = {
  layoutType: 'vertical',
  layoutWidth: 'fluid',
  leftSidebarType: 'dark',
  topbar: 'light',
  loader: false,

  show_menu: true,
  show_routes: true,
  menu_type: null,
  is_menu_collapsed: false,
}

export const mutations = {
  CHANGE_LAYOUT(state, layoutType) {
    state.layoutType = layoutType;
  },
  CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
    state.layoutWidth = layoutWidth;
  },
  CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
    state.leftSidebarType = leftSidebarType;
  },
  CHANGE_TOPBAR(state, topbar) {
    state.topbar = topbar;
  },
  LOADER(state, loader) {
    state.loader = loader
  },


  UPDATE_MENU(state, payload){
    state.show_menu = payload.showMenu;
    state.menu_type = payload.type;
    state.show_routes = payload.showRoutes;
  },

  resetStore(state, payload){
    state.show_menu = payload;
    state.show_routes = payload;
    state.menu_type = payload;
  }
}

export const actions = {
  //* Menu Layout 
  updateMenuType({commit}, payload){
    commit('UPDATE_MENU', payload);
  },
  /*updateMenuType(payload){
      this.menu_type = payload.type;
      this.show_router_menu = payload.showRoutes;
  },*/
  clearAll({commit}){
    return new Promise((resolve) => {
        commit('resetStore', null);
        resolve();
    })
  },



  //* SKOTE LAYOUT STUFF 
  changeLayoutType({ commit }, { layoutType }) {
    commit('CHANGE_LAYOUT', layoutType);
  },
  changeLayoutWidth({ commit }, { layoutWidth }) {
    commit('CHANGE_LAYOUT_WIDTH', layoutWidth)
  },
  changeLeftSidebarType({ commit }, { leftSidebarType }) {
    commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType)
  },
  changeTopbar({ commit }, { topbar }) {
    commit('CHANGE_TOPBAR', topbar)
  },
  changeLoaderValue({ commit }, { loader }) {
    commit('LOADER', loader)
  }
}


